import { TemplateRef } from '@angular/core';

import * as d3 from 'd3';

export class Treeview2Model<T>
{
    private _templates: TemplateRef<any>[] = [];
    set templates (value: TemplateRef<any>[])
    {
        this._templates = [null, ...value];
    }
    get templates (): TemplateRef<any>[]
    {
        return this._templates;
    }

    constructor (
        public cid: string,
        public lid: string,
        public cnid: string,
        public items: d3.HierarchyNode<any>[] = null,
        public className: any = null,
        public showTitle: boolean = true,
        public treeTitle: string = '',
        public treeNodeId: string = '',
        public iconExpand: string = 'fa-plus-square',
        public iconCollapse: string = 'fa-minus-square',
        public iconLeaf: string = 'fa-square-o'
    )
    { }

    public getItemById (entryId: string): d3.HierarchyNode<any>
    {
        const found = this.items.find((item: d3.HierarchyNode<any>): boolean =>
            item.id === entryId
        );

        return found;
    }
}
